import * as React from "react";
import classNames from "classnames";
import { DragLayer } from "react-dnd";
import { WithStyles, Theme, createStyles, withStyles } from "@material-ui/core";

import Typography from "@material-ui/core/Typography";

export interface DragLayerProps {}

interface DragLayerConnectedProps extends WithStyles<typeof styles> {
	item?: object;
	itemType?: string;
	currentOffset?: {
		x: number;
		y: number;
	};
	isDragging?: boolean;
}

type Props = DragLayerProps & DragLayerConnectedProps;

export class ComposerDragLayer extends React.Component<Props, {}> {
	private x = 0;
	private y = 0;

	private renderPreview(value: string) {
		const { currentOffset, classes, isDragging } = this.props;

		return (
			<div
				className={classNames(classes.item, {
					[classes.itemVisible]: isDragging
				})}
				style={{ top: `${this.y - 23}px`, left: `${this.x - 23}px` }}
			>
				<Typography className={classes.label}>{value}</Typography>
			</div>
		);
	}

	public render() {
		const { itemType, currentOffset } = this.props;
		const item = this.props.item as any;

		switch (itemType) {
			case "ReservationItem":
				if (currentOffset && currentOffset.x && currentOffset.y) {
					this.x = currentOffset.x;
					this.y = currentOffset.y;
				}
		}

		return this.renderPreview((item && item.peopleCount) || "");
	}
}

@DragLayer(monitor => ({
	item: monitor.getItem(),
	itemType: monitor.getItemType(),
	currentOffset: monitor.getClientOffset(),
	isDragging: monitor.isDragging()
}))
class DecoratedComposerDragLayer extends ComposerDragLayer {}

const styles = (theme: Theme) =>
	createStyles({
		root: {},
		item: {
			position: "absolute",
			zIndex: 50,
			pointerEvents: "none",
			width: 32,
			height: 32,
			borderRadius: "100%",
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			cursor: "grab",
			margin: 3,
			background: theme.palette.primary.main,
			boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)",
			opacity: 0,
			transition: "opacity 0.2s ease, width 0.2s ease, height 0.2s ease"
		},
		itemVisible: {
			opacity: 1,
			width: 46,
			height: 46
		},
		label: {
			color: "white",
			fontSize: "1.2rem"
		}
	});

export const ConnectedComposerDragLayer = withStyles(styles)(
	DecoratedComposerDragLayer
);
